<template>
  <div>
    <v-container fluid>
      <v-layout>
        <v-row>
          <v-col sm="12">
            <div class="font-weight-light display-1">
              Puesto de {{ trabajoSeleccionado.nombrePuesto }}
            </div>
          </v-col>
          <v-col sm="12">
            <v-list class="py-0">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account-tie-voice</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-light">
                  Área de Postulación:
                  <span class="font-weight-bold">{{
                    trabajoSeleccionado.areaEmpresa
                  }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-calendar-clock</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-light">
                  Fecha de Validez:
                  <span class="font-weight-bold">{{
                    formatDateTable(trabajoSeleccionado.fechaValidez)
                  }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-calendar-remove</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-light">
                  Fecha de Vencimiento:
                  <span class="font-weight-bold">{{
                    formatDateTable(trabajoSeleccionado.fechaVencimiento)
                  }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="font-weight-light">
                  <span class="font-weight-bold">{{
                    trabajoSeleccionado.postulantes.length
                  }}</span>
                  Postulante(s) en total
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headersListaTrabajos"
      :items="trabajoSeleccionado.postulantes"
      class="elevation-1"
      fixed-header
      show-expand
      item-key="_id"
    >
      <template v-slot:item.fechaPostulacion="{ item }">{{
        formatDateTable(item.fechaPostulacion)
      }}</template>
      <template v-slot:item.idPostulante.nombres="{ item }">{{
        `${item.idPostulante.nombres} ${item.idPostulante.apellidoPaterno} ${item.idPostulante.apellidoMaterno}`
      }}</template>
      <template v-slot:expanded-item="{ headers, item }" style="width: 100%">
        <td :colspan="headers.length">
          <detalle-postulante
            :user-data="item.idPostulante"
          ></detalle-postulante>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DetallePostulante from "./DetallePostulante.vue";

export default {
  components: {
    DetallePostulante
  },
  props: ["trabajoSeleccionado"],
  data: function () {
    return {
      headersListaTrabajos: [
        {
          text: "Nombre Completo",
          value: "idPostulante.nombres",
          align: "center"
        },
        {
          text: "Fecha de Postulación",
          value: "fechaPostulacion",
          align: "center"
        },
        {
          text: "Correo UNI",
          value: "idPostulante.correoUNI",
          align: "center"
        },
        {
          text: "Nivel Académico",
          value: "idPostulante.estadoAcademicoAlumno",
          align: "center"
        },
        { text: "", value: "data-table-expand" }
      ]
    };
  },

  methods: {
    formatDateTable(date) {
      let parsedDate = new Date(date);
      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
      return `${parsedDate.toLocaleDateString(
        "es-PE",
        options
      )} ${parsedDate.toLocaleTimeString("en-US")}`;
    }
  },

  mounted() {
    console.log(this.trabajoSeleccionado);
  }
};
</script>

<style>
</style>